<template>
  <div class="page-wrap" v-if="viewport">
    <banner :nav-index="0">
      <template slot="banner">
        <div class="banner">
          <div class="centre" :style="{'will-change': 'transform',transform: `translate3d(0,${transLateY}px,0)`}">
            <div class="letter">
              <h1>Wearable Intelligence<br/>And Empowering AI</h1>
              <div class="line"></div>
              <p class="top">
                To expand and recreating human sensorium with novel interactive technologies between human and machines;
                to achieve human digital and machine immortality through AI-based wearable robotic technologies.
              </p>
              <p>
                Our mission is to provide high-quality, personalized services for people’s health, entertainment experience, and happiness via intelligent wearable robotics.
              </p>
              <div class="frame">
                Reshape The Future.
              </div>
            </div>
            <div class="untitled">
              <img class="cerebrum" src="@/assets/web2.0animation.gif">
              <img class="round" src="@/assets/Ellipse 3.png">
              <img class="slash" src="@/assets/Ellipse 4.png">
            </div>
          </div>
        </div>
      </template>
    </banner>
    <div style="position: relative;z-index: 2;background-color: #fff">
      <company></company>
      <interaction></interaction>
      <machine></machine>
      <provide></provide>
      <cooperation></cooperation>
      <div class="footer-box">
        <relation :isHome="true"></relation>
      </div>
    </div>
  </div>
  <div v-else class="phone-wrap">
    <div class="background">
      <div class="nav">
        <div class="logo">
          <img src="@/assets/phone/phone-logo.png">
        </div>
        <div @click="onList" class="fork">
          <span class="iconfont icon-liebiaoshitucaidan"></span>
        </div>
      </div>
      <div class="alternately">
        <h1>Wearable Intelligence</h1>
        <h2>And Empowering AI</h2>
        <div class="line"></div>
        <div class="brain">
          <img class="pic" src="@/assets/web2.0animation.gif">
          <img class="across" src="@/assets/phone/Ellipse3.png">
          <img class="vertical" src="@/assets/phone/Ellipse4.png">
        </div>
        <div class="text">
          <p>
            To expand and recreating human sensorium with novel interactive technologies between human and machines; to
            achieve human digital and machine immortality through AI-based wearable robotic technologies.
          </p>
          <p class="top">
            Our mission is to provide high-quality, personalized services for people’s health, entertainment experience, and happiness via intelligent wearable robotics.
          </p>
        </div>
      </div>

      <div v-show="list" class="list">
        <phoneNav @onHide="onHide"></phoneNav>
      </div>
    </div>
    <div class="technology">
      <div class="mro">
        <img src="@/assets/phone/MaschineRobot5.png">
      </div>
      <div class="pic">
        <img src="@/assets/phone/Technology.png">
      </div>
      <div class="line"></div>
      <div class="letter">
        <img src="@/assets/phone/ReshapetheFuture.png">
      </div>
      <div class="text">
        <p>
          Maschine Robot is a wearable robotics company based on technologies in wearable sensors, data intelligence,
          and human-machine interactions. Our R&D centers locate in Boston, US, and Beijing, China. Our core team
          consists of members with background in related technology industries and renowned universities.
        </p>

        <p class="top">
          Our key products are centered around wearables and human-machine integrative systems empowered by data
          intelligence. We aim to build a new paradigm, via incorporating wearables and artificial intelligence, of
          personal healthcare and interactions for the future, and to provide solutions for challenges stemmed from
          population ageing.
        </p>
      </div>
    </div>

    <div class="img-text" :style="{backgroundImage: `url(${banner1})`}">
      <div class="text">
        <h1>Smart Wearables<br/> Data Collection</h1>
        <p class="top">Real-time human body data<br/> collection under the<br/> collaboration of wearable<br/> devices and AI algorithms.
        </p>
      </div>
    </div>
    <div class="img-text end" :style="{backgroundImage: `url(${banner2})`}">
      <div class="text">
        <h1>Human-machine<br/> interactions with<br/> smart wearables</h1>
        <p class="top">Internet-of-every-mind<br/>
          embodied by BCI and AI</p>
      </div>
    </div>
    <div class="img-text" :style="{backgroundImage: `url(${banner3})`}">
      <div class="text">
        <h1>Human-Computer Interactionh<br/> Empowering AI</h1>
        <p class="top">Emotional interaction<br/> between bionic robots and<br/> smart wearables.<br/></p>
      </div>
    </div>
    <div class="cooperation">
      <h1>Our collaborators</h1>
      <div class="unit">
        <div class="icon">
          <img src="@/assets/phone/logo1.png">
          <p>MIT</p>
        </div>
        <div class="icon">
          <img src="@/assets/phone/logo2.png">
          <p>Peking&nbsp;Union<br/>Medical&nbsp;College<br/>Hospital</p>
        </div>
          <div class="icon">
              <img src="@/assets/phone/anzhen.png">
              <p>Anzhen&nbsp;Hospital</p>
          </div>
          <div class="icon">
              <img src="@/assets/phone/fuwai.png">
              <p>Fuwai&nbsp;Hospital</p>
          </div>
        <div class="icon">
          <img src="@/assets/phone/logo3.png">
          <p>Stanford<br/> University</p>
        </div>
        <div class="icon">
          <img src="@/assets/phone/logo4.png">
          <p>Shanghai<br/> Jiao Tong<br/> University</p>
        </div>
      </div>
    </div>
    <div>
      <phoneFooter></phoneFooter>
    </div>
  </div>
</template>

<script>


import banner from '@/components/banner'
import relation from '@/components/footer'
import company from './components/company'
import interaction from './components/interaction'
import machine from './components/machine'
import cooperation from './components/cooperation'
import provide from './components/provide'
import phoneNav from '@/components/phoneNav/index'
import phoneFooter from "@/components/phoneFooter";

export default {
  components: {
    phoneFooter,
    phoneNav,
    banner,
    company,
    interaction,
    cooperation,
    machine,
    relation,
    provide,
  },
  data() {
    return {
      toTop: 0,
      transLateY: 0,
      clientWidth: 0,
      screenWidth: null,
      viewport: true,
      list: false,
      banner1: require('../../assets/phone/banner1.png'),
      banner2: require('../../assets/phone/banner2.jpg'),
      banner3: require('../../assets/phone/banner3.png'),
    }

  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  watch: {
    screenWidth: function (n, o) {
      if (n <= 1024) {
        this.viewport = false
      } else {
        this.viewport = true
      }
    }
  },
  mounted() {
    this.screenWidth = document.body.clientWidth
    if (document.documentElement.clientWidth < 1280) {
      this.viewport = false
    }
    window.onresize = () => {
      //屏幕尺寸变化
      return (() => {
        this.screenWidth = document.body.clientWidth

      })()
    }
  },

  methods: {

    onList() {
      setTimeout(() => {
        this.list = true
      }, 200)

    },

    onHide() {
      setTimeout(() => {
        this.list = false
      }, 200)

    },

    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop < 900) {
        if (this.toTop <= scrollTop) {
          this.transLateY = scrollTop / 10
        } else {
          this.transLateY = -scrollTop / 10
        }
      }
      this.toTop = scrollTop
    }
  },

}
</script>

<style scoped>


.banner {
  height: 900px;
}

.banner .centre {
  display: flex;
  margin: 0 auto;
  height: 944px;
  width: 1200px;
}

.banner .centre .letter {
  padding-top: 68px;
}

.banner .centre .letter h1 {
  color: #FFFFFF;
  font-size: 42px;
  line-height: 72px;
  font-weight: 700;
  font-style: normal;
}

.banner .centre .letter .line {
  margin-top: 30px;
  width: 60px;
  height: 6px;
  background-color: #FFFFFF;
}

.banner .centre .letter p {
  width: 684px;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
  color: #FFFFFF;
}

.banner .centre .letter .top {
  margin-top: 40px;
  padding-bottom: 24px;
}

.banner .centre .letter .frame {
  margin-top: 33px;
  padding: 13px 0;
  width: 400px;
  font-style: normal;
  font-weight: 700;
  font-size: 34px;
  line-height: 40px;
  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  color: #FFFFFF;
}

.banner .centre .untitled {
  margin-left: 115px;
  margin-top: 172px;
  width: 516px;
  height: 498px;
  position: relative;
}

.banner .centre .untitled .cerebrum {
  width: 636px;
  position: absolute;
  top: -82px;
  left: -86px;
  z-index: 99;

}

.banner .centre .untitled .round {
  position: absolute;
  top: 52px;
  left: -80px;
}

.banner .centre .untitled .slash {
  position: absolute;
  top: 56px;
  left: -18px;
}

.footer-box {
  background-image: linear-gradient(to top left, #814e54, #545f65, #8cafb8);
}

.list {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
}

.background {
  background-image: url("../../assets/phone/Group770.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}

.nav {
  display: flex;
  justify-content: space-between;
  padding: 1.14rem 0.6rem 0;
}

.nav .logo {
  display: flex;
  align-items: center;
  height: 0.43rem;
}

.nav .logo img {
  height: 0.35rem;
}

.nav .fork {
  height: 0.43rem;
  line-height: 0.43rem;
  color: #FFFFFF;
}

.nav .fork .iconfont {
  font-size: 0.36rem;
}

.phone-wrap .alternately {
  padding-top: 1.1rem;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  color: #FFFFFF;
}

.alternately {
  padding-bottom: 1rem;
  position: relative;
}

.alternately h1 {
  position: absolute;
  left: 1.76rem;
  /*top: 1.1rem;*/
  font-weight: 700;
  font-size: 0.38rem;
  line-height: 0.62rem;
}


.alternately h2 {
  font-weight: 700;
  font-size: 0.38rem;
  line-height: 0.62rem;
  position: absolute;
  top: 1.8rem;
  left: 1.9rem;
}

.alternately .line {
  margin-top: 1.55rem;
  width: 0.24rem;
  height: 0.03rem;
  background-color: #FFFFFF;
}

.alternately .brain {
  position: relative;
  z-index: 6;
  /*width: 5.66rem;*/
  margin-top: 0.18rem;
  text-align: center;
}

.alternately .brain .pic {
  width: 6rem;
}

.alternately .brain .across {
  position: absolute;
  top: 1.3rem;
  left: 0.3rem;
  /*height: 2.21rem;*/
  width: 5.34rem;
}

.alternately .brain .vertical {
  position: absolute;
  top: 1.3rem;
  left: 0.54rem;
  /*height: 2.59rem;*/
  width: 4.8rem;
}

.alternately .text {
  padding: 0 0.6rem;
}

.alternately .text p {
  font-size: 0.24rem;
  line-height: 0.36rem;
}

.alternately .text .top {
  margin-top: 0.2rem;
}

.technology {
  padding: 0.7rem 0.6rem 0.63rem;
  background-image: url("../../assets/phone/iStock-1181106241.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.technology .mro {
  line-height: 0;
}

.technology .mro img {
  height: 0.28rem;
}

.technology .pic {
  margin-top: 0.34rem;
  line-height: 0;
}

.technology .pic img {
  height: 0.24rem;
}

.technology .line {
  margin-top: 0.39rem;
  height: 0.05rem;
  width: 0.44rem;
  background-color: #000000;
}

.technology .letter {
  margin-top: 0.42rem;
  line-height: 0;
}

.technology .letter img {
  height: 0.32rem;
}

.technology .text {
  margin-top: 0.4rem;
}

.technology .text p {
  font-size: 0.24rem;
  line-height: 0.36rem;
  color: #111111;
  /*letter-spacing: 0.02rem;*/
}

.technology .text .top {
  margin-top: 0.2rem;
}

.img-text {
  padding: 1.7rem 0.6rem 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 5.7rem;
}

.img-text h1 {
  font-weight: 700;
  font-size: 0.32rem;
  line-height: 0.48rem;
  /*width: 3.72rem;*/
}

.img-text p {
  /*width: 3.72rem;*/
  font-size: 0.24rem;
  line-height: 0.38rem;
}

.end {
  display: flex;
  /*justify-content: flex-end;*/
  padding: 2rem 0 1.2rem 4.18rem;
}


.img-text .top {
  margin-top: 0.3rem;
}

.cooperation {
  padding: 1rem 0.6rem 1.39rem;
  background: #F0F3F5;
}

.cooperation h1 {
  font-weight: 700;
  font-size: 0.32rem;
  line-height: 0.3rem;
}

.cooperation .unit {
  display: flex;
    flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0.5rem;
}

.cooperation .unit .icon {
  position: relative;
  width: 1.48rem;
  height: 2rem;
}

.cooperation .unit .icon img {
  width: 1.48rem;
}

.cooperation .unit .icon p {
  position: absolute;
  top: 1.09rem;
  font-size: 0.18rem;
  line-height: 0.28rem;
  color: #111111;
  text-align: center;
  width: 100%;
}

</style>
